import React from "react";
import WidgetAccountedFor from "./accountedFor";
import WidgetDocuments from "./documents";
import WidgetEvidence from "./evidence";
import "./style.scss";
import WidgetVatSummary from "./vatSummary";

const WidgetsPrecogContainer = () => {
  return (
    <div className="containersPrecogWidget">    
      <WidgetEvidence />
      <WidgetAccountedFor />
      <WidgetVatSummary />
      <WidgetDocuments />
    </div>
  );
};

export default WidgetsPrecogContainer;